import { NavLink } from 'react-router-dom';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import { companyInfo, fullAddress } from '../constants/companyInfo';
import { footerLinks } from '../constants/siteLinks';

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-slate-900 py-14 text-slate-200">
      <div className="pointer-events-none absolute -left-20 top-8 h-56 w-56 rounded-full bg-teal-700/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 right-8 h-72 w-72 rounded-full bg-cyan-500/20 blur-3xl" />

      <div className="mero-wrapper relative grid gap-8 md:grid-cols-3">
        <div>
          <div className="inline-flex items-center gap-3">
            <img
              src="/goldenhc-logo.png"
              alt={companyInfo.displayName}
              className="h-10 w-10 rounded-full object-cover ring-1 ring-teal-500/60"
            />
            <h3 className="text-xl font-semibold text-white">{companyInfo.legalName}</h3>
          </div>
          <p className="mt-3 text-sm leading-7 text-slate-300">
            <span className="inline-flex items-center gap-2">
              <FaMapMarkerAlt className="text-teal-300" />
              {fullAddress}
            </span>
            <br />
            <span className="inline-flex items-center gap-2">
              <FaPhoneAlt className="text-teal-300" /> Phone: {companyInfo.phone}
            </span>
            <br />
            <span className="inline-flex items-center gap-2">
              <FaEnvelope className="text-teal-300" /> Email: {companyInfo.email}
            </span>
          </p>
        </div>

        <div>
          <h4 className="text-lg font-semibold text-white">Useful Links</h4>
          <ul className="mt-3 space-y-2 text-sm text-slate-300">
            {footerLinks.map((link) => (
              <li key={link.to}>
                <NavLink to={link.to} className="hover:text-white">
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-semibold text-white">Our Mission</h4>
          <p className="mt-3 text-sm text-slate-300">
            Providing compassionate home care services for eligible participants and
            families with dignity, trust, and consistency.
          </p>
        </div>
      </div>

      <div className="mero-wrapper relative mt-10 border-t border-slate-700 pt-6 text-sm text-slate-400">
        Copyright Golden Hands Home Care LLC. All Rights Reserved.
      </div>
    </footer>
  );
}
